// @flow

import { observer } from "mobx-react";
import React from "react";

import logo from "app/assets/images/logo.png";
import logoInverse from "app/assets/images/logo-inverse.png";
import logoDot from "app/assets/images/logo-dot.png";
import logoDotInverse from "app/assets/images/logo-dot-inverse.png";
import logoNoBeta from "app/assets/images/logo-inverse-no-beta.png";

type Props = {
    theme?: string,
    type?: string
};

@observer
export default class Logo extends React.Component<Props> {
    getLogo() {
        const theme = this.props.theme;
        const type = this.props.type;

        if (theme === "dark") {
            if (type === "dot") {
                return logoDotInverse;
            }

            return logoInverse;
        }

        if (type === "dot") {
            return logoDot;
        }

        if (type === "no-beta") {
            return logoNoBeta;
        }

        return logo;
    }

    render() {
        return <img className="Logo" src={this.getLogo()} alt="Timelinely" />;
    }
}



// WEBPACK FOOTER //
// ./src/app/components/Logo/Logo.js